import React, { useState } from 'react';
import Pagination from '../../../common/Pagination'

const FeedbackTab = ({ patientFeedbacks, onPageChange, getFeedbackIcon, formatDate }) => {
    const [currentPage, setCurrentPage] = useState(0);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        onPageChange(page);
    };
    console.log("Patient Feedbaks:",patientFeedbacks)
    return (
        <div className="card border-0 shadow-sm">
            <div className="card-header bg-transparent border-0">
                <h5 className="card-title mb-0">
                    <i className="bi bi-emoji-smile text-warning me-2"></i>
                    Patient Feedback
                    <span className="badge bg-primary ms-2 text-white">{patientFeedbacks?.totalElements}</span>
                </h5>
            </div>
            <div className="card-body">
                {patientFeedbacks?.content?.length > 0 ? (
                    <>
                        <div className="table-responsive">
                            <table className="table table-hover align-middle">
                                <thead>
                                <tr>
                                    <th>Patient</th>
                                    <th>Feedback</th>
                                    <th>Date</th>

                                </tr>
                                </thead>
                                <tbody>
                                {patientFeedbacks.content.map((feedback) => (
                                    <tr key={feedback.id}>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <div className="avatar bg-secondary text-white rounded-circle p-2 me-3">
                                                    {feedback.patientName.split(' ').map(n => n.charAt(0)).join('')}
                                                </div>
                                                <div>
                                                    <h6 className="mb-0">{feedback.patientName}</h6>
                                                    <small className="text-muted">ID: {feedback.patientId.slice(0, 8)}...</small>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            {getFeedbackIcon(feedback.feedback)}
                                        </td>
                                        <td>
                                            <small className="text-muted">{formatDate(feedback.createdAt)}</small>
                                        </td>

                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>

                        <Pagination
                            currentPage={currentPage}
                            totalPages={patientFeedbacks.totalPages}
                            onPageChange={handlePageChange}
                            totalElements={patientFeedbacks.totalElements}
                            pageSize={patientFeedbacks.pageable?.pageSize || 10}
                        />
                    </>
                ) : (
                    <div className="text-center py-5">
                        <i className="bi bi-emoji-smile display-1 text-muted"></i>
                        <h5 className="text-muted mt-3">No patient feedback</h5>
                        <p className="text-muted">Patient feedback will appear here once they submit their reviews</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FeedbackTab;